import { useRef, useState, useEffect } from 'react';
const useOutsideClick = (shouldListen) => {
    const ref = useRef();
    const [isOutsideClick, setIsOutsideClick] = useState(false);
    const handleClick = (e) => {
        // istanbul ignore else
        if (ref && ref.current) {
            !ref.current.contains(e.target)
                ? setIsOutsideClick(true)
                : setIsOutsideClick(false);
        }
    };
    useEffect(() => {
        const addListener = () => window.addEventListener('click', handleClick);
        const removeListener = () => window.removeEventListener('click', handleClick);
        if (shouldListen) {
            addListener();
        }
        else {
            removeListener();
            setIsOutsideClick(false);
        }
        return () => removeListener();
    }, [shouldListen]);
    return [ref, isOutsideClick];
};
export default useOutsideClick;
//# sourceMappingURL=index.js.map